// extracted by mini-css-extract-plugin
export default {"formContact":"Contact_formContact__dxZC3","formGroup":"Contact_formGroup__cyHwg","button":"Contact_button__eXfrS"};